"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherMappingCode = void 0;
var VoucherMappingCode;
(function (VoucherMappingCode) {
    VoucherMappingCode["PEPPOL"] = "peppol";
})(VoucherMappingCode = exports.VoucherMappingCode || (exports.VoucherMappingCode = {}));
